export default {
  PROXIMITY: 'proximity',
  VIEWERS: 'viewers',
  GAMES: 'active_games',
};
